import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';
import { Button, Icon } from '@paypalcorp/pp-react';

const setShiftedX = (index, { isRtl, shiftValue, setX, x }) => {
  if (index === 0) {
    return setX(x * index);
  } else if (isRtl) {
    return setX(index * shiftValue);
  }
  return setX(-index * shiftValue);
};

const setDotBackgroundColor = (index, { isRtl, x, shiftValue }) => {
  if (isRtl) {
    return index === x || index * shiftValue === x ? 'rgb(0,112,186)' : '';
  }
  return index === x || -(index * shiftValue) === x ? 'rgb(0,112,186)' : '';
};

const calculateDisabledButton = ({ isRtl, x, lastIndex, shiftValue }) =>
  isRtl ? x === lastIndex * shiftValue : x === -lastIndex * shiftValue;

const DetailsTestimonials = ({
  handleClickFPTI,
  fptiImpression,
  toolTileProps,
  componentContent = {}
}) => {
  const { testimony } = componentContent;

  if (!testimony) {
    fireDetailsPageComponentFailureFpti({
      data: { testimony },
      componentName: 'DetailsTestimonials',
      fptiImpression
    });
    return null;
  }
  const directionality = toolTileProps?.app?.context?.locale?.directionality;
  const isRtl = directionality === 'rtl';
  const testimonials = parseData(testimony);
  const shiftValue = 100;
  const [x, setX] = useState(0);

  const handlePagination = index => {
    handleClickFPTI('testimonial_nav_dot');
    return setShiftedX(index, { isRtl, shiftValue, setX, x });
  };
  const dotBackGroundColor = index => ({
    backgroundColor: setDotBackgroundColor(index, { isRtl, x, shiftValue })
  });

  const disableButton = () =>
    calculateDisabledButton({ isRtl, x, lastIndex, shiftValue });

  const goLeft = () => {
    handleClickFPTI('testimonial_left_arrow');
    return isRtl ? setX(x - shiftValue) : setX(x + shiftValue);
  };

  const goRight = () => {
    handleClickFPTI('testimonial_right_arrow');
    return isRtl ? setX(x + shiftValue) : setX(x - shiftValue);
  };

  const testimonialCount = testimonials.length;
  const lastIndex = testimonialCount - 1;
  const showIcon = testimonialCount <= 1 ? 'hidden' : '';
  const opacityLeftArrow = '0.7';
  const opacityRightArrow = '0.7';

  if (testimonialCount <= 0) {
    return null;
  }

  return (
    <div className="testimonial-wrapper" aria-hidden={true}>
      <div className="testimonial-container-1">
        <div className="testimonial-slider">
          {testimonials.map((item, index) => {
            return (
              <div
                key={index}
                className="testimonial-slide"
                style={{ transform: `translateX(${x}%)` }}
              >
                <div className="testimonial-container-2">
                  <div className="testimonial-testimony"> {item.text}</div>
                  <div className="testimonial-author-company-container">
                    <div className="testimonial-author"> {item.author}</div>
                    <div className="testimonial-company"> {item.company}</div>
                  </div>
                </div>
                <img
                  className={`lazyload ${
                    item.image ? 'testimonial-photo' : 'testimonial-no-display'
                  }`}
                  data-src={item.image}
                  alt=""
                />
              </div>
            );
          })}
        </div>
        <Icon
          name={isRtl ? 'chevron-right' : 'chevron-left'}
          as={Button}
          disabled={x === 0}
          id="testimonial-goLeft"
          aria-hidden={true}
          onClick={goLeft}
          style={{ visibility: `${showIcon}`, opacity: `${opacityLeftArrow}` }}
        />

        <Icon
          name={isRtl ? 'chevron-left' : 'chevron-right'}
          as={Button}
          id="testimonial-goRight"
          disabled={disableButton()}
          aria-hidden={true}
          onClick={goRight}
          style={{ visibility: `${showIcon}`, opacity: `${opacityRightArrow}` }}
        />

        <div className="testimonial-dot-container ">
          {testimonials.map((subItem, index) => (
            <Button
              onClick={() => handlePagination(index)}
              key={index}
              aria-hidden={true}
              style={dotBackGroundColor(index)}
              className={
                testimonials.length === 1
                  ? 'testimonial-dot-hidden'
                  : 'testimonial-dot'
              }
            ></Button>
          ))}
        </div>
      </div>
    </div>
  );
};

DetailsTestimonials.propTypes = {
  componentContent: PropTypes.object,
  fptiImpression: PropTypes.func.isRequired,
  handleClickFPTI: PropTypes.func.isRequired,
  toolTileProps: PropTypes.object
};

export default DetailsTestimonials;
